"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = require("lodash");
var _react = require("react");
var _ = require("./");
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useFetch = function useFetch(url, initialValue) {
  var isAllowed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var disableGlobalErrorHandler = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var onLoaded = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _lodash.noop;
  var mock = arguments.length > 5 ? arguments[5] : undefined;
  var options = arguments.length > 6 ? arguments[6] : undefined;
  var _useState = (0, _react.useState)(initialValue),
    _useState2 = _slicedToArray(_useState, 2),
    data = _useState2[0],
    setData = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var fetch = (0, _react.useCallback)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var res, status, _data, _res, error;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (isAllowed) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            _context.prev = 2;
            setLoading(true);
            _context.next = 6;
            return disableGlobalErrorHandler ? _.apiWithoutErrorsHandler.get(url, options) : _.api.get(url, options);
          case 6:
            res = _context.sent;
            status = res.status, _data = res.data;
            if (status === 200) {
              setData(_data);
            }
            return _context.abrupt("return", _data);
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](2);
            _res = _context.t0.response;
            if (!((_res === null || _res === void 0 ? void 0 : _res.status) === 404 && mock)) {
              _context.next = 18;
              break;
            }
            setData(mock);
            return _context.abrupt("return", mock);
          case 18:
            console.error(_res);
            error = _res === null || _res === void 0 ? void 0 : _res.data;
            setData({
              error: error
            });
            return _context.abrupt("return", error);
          case 22:
            _context.prev = 22;
            setLoading(false);
            onLoaded();
            return _context.finish(22);
          case 26:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 12, 22, 26]]);
  })), [url, isAllowed, disableGlobalErrorHandler, onLoaded]);
  (0, _react.useEffect)(function () {
    fetch();
  }, [isAllowed, url]);
  return {
    loading: loading,
    data: data,
    refetch: fetch
  };
};
var _default = useFetch;
exports.default = _default;